// Autogenerated locales - do not modify
/* tslint:disable quotemark variable-name */
export const STROLLER_ADD_QUESTION = "Zeptej se v poradn\u011b";
export const STROLLER_BRAND_LINKED_ARTICLES_OF_brand = "\u010cl\u00e1nky a recenze ko\u010d\u00e1rk\u016f %(brand)s";
export const STROLLER_BRAND_LINKED_OBJECTS_OF_brand = "Ot\u00e1zky v poradn\u011b ke ko\u010d\u00e1rk\u016fm %(brand)s";
export const STROLLER_MORE_ABOUT_BRAND = "V\u00edce o zna\u010dce";
export const STROLLER_OFFICIAL_SITE_link = "Ofici\u00e1ln\u00ed str\u00e1nka %(link)s";
export const STROLLERS_NO_RESULTS = "Nena\u0161li jsme \u017e\u00e1dn\u00e9 ko\u010d\u00e1rky.";
export const STROLLERS_SEARCH_HOMEPAGE_BTN_TITLE = "Najdi ko\u010d\u00e1rek podle sv\u00fdch p\u0159edstav";
export const STROLLER_STROLLEROPEDIA = "Ko\u010d\u00e1rkopedie";
